var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com4",class:{'bor':_vm.bor===true}},[_vm._v("\n    我是组件4\n")])}
var staticRenderFns = []

export { render, staticRenderFns }